import press_en from "./press-en.json";
import press_tc from "./press-tc.json";
import press_sc from "./press-sc.json";
import { Language } from "../../context";

export type PressListData = {
  title: string;
  url: string;
  date: string;
};

/**
 * Processes raw press JSON data into a standardized list of PressListData objects.
 *
 * @param jsonData - The raw JSON array containing press data.
 *
 * @returns A normalized array of PressListData objects.
 *
 * */

const processPressJson = (jsonData: any[]): PressListData[] => {
  return jsonData?.map((item) => ({
    title: item?.title ?? "",
    url: item?.url ?? "",
    date: item?.date ?? "",
  }));
};

const videos_list_en: PressListData[] = processPressJson(press_en);
const videos_list_tc: PressListData[] = processPressJson(press_tc);
const videos_list_sc: PressListData[] = processPressJson(press_sc);

export const pressLanguageMap: Record<Language, PressListData[]> = {
  [Language.EN]: videos_list_en,
  [Language.TC]: videos_list_tc,
  [Language.SC]: videos_list_sc,
};
